<nz-badge [nzDot]="hasNegotiations$ | async" [nzOffset]="offset">
  <ng-content></ng-content>
</nz-badge>
